module.exports = __webpack_public_path__ + "media/images/sp/articles/report_01-6bd787e0cada528f1c1a3b47332d2c84.webp";